/** Slider resource from the CMS API. */
export interface Slider {
  id: number;
  title: string;
  subtitle: string | null;
  image: string;
  link: string | null;
  sort_order: number;
  is_active: boolean;
}

export interface SliderCreateInput {
  title?: string;
  subtitle?: string;
  link?: string;
  sort_order?: number;
  is_active?: boolean;
  image: File;
}

export interface SliderUpdateInput {
  title?: string;
  subtitle?: string;
  link?: string;
  sort_order?: number;
  is_active?: boolean;
  image?: File;
}

/** Display shape used by BannerSlider on the storefront. */
export type BannerSlideDisplay = {
  id: string;
  title: string;
  subtitle?: string;
  image: string;
  imageAlt?: string;
  cta?: string;
  ctaHref?: string;
  bgClass?: string;
  overlayClass?: string;
  textClass?: string;
  variant?: 'hero' | 'promo';
};

export function sliderToBannerSlide(slider: Slider): BannerSlideDisplay {
  return {
    id: String(slider.id),
    title: slider.title,
    subtitle: slider.subtitle ?? undefined,
    image: slider.image,
    imageAlt: slider.title,
    cta: slider.link ? 'Learn more' : undefined,
    ctaHref: slider.link ?? undefined,
    variant: 'hero',
  };
}

/** @deprecated Use BannerSlideDisplay or Slider */
export type SlideItem = BannerSlideDisplay;
